// homepage-sections.js — the text of three homepage sections, shared by BOTH
// render paths: the React Home in App.jsx and the crawler #ssr-content block
// in index.astro. Same single-source rule as homepage-journeys.js /
// aircraft-content.js: the 17 Aug crawl audit found these three sections
// existed ONLY in the React path. The text is MOVED here verbatim, not
// rewritten — scenario-341 pins it character-for-character.
//
// Dynamic parts stay parameters (brand name, CMS steps, arrival minutes,
// full-payment days) so both callers feed them from the same data they
// already hold; the wording around them is frozen.

export function safetySection(brandName) {
  return {
    heading: 'The highest safety standards in Greek aviation',
    intro: brandName + ' is a private helicopter charter broker. We work exclusively with HCAA-licensed, EASA-compliant operators -- so every aircraft, pilot, and procedure meets the highest standards in European civil aviation.',
    points: [
      'Only HCAA-licensed operators in our network',
      'EASA-compliant aircraft and maintenance',
      'Experienced, type-rated pilots on every flight',
      'Full insurance and passenger protection on all charters',
    ],
  };
}

// CMS steps win (homepage.steps); the fallback is the frozen copy. The React
// section renders exactly this list — icons/numbering are presentation.
export function howItWorksSteps(cmsSteps, arrivalBeforeMin) {
  if (Array.isArray(cmsSteps) && cmsSteps.length) return cmsSteps;
  return [
    { title: 'Search', body: 'Enter your route, date, and number of passengers. See available aircraft and exact prices instantly.' },
    { title: 'Select & confirm', body: "Choose your aircraft, review the cancellation policy, and confirm. We place a hold on your card — you're not charged until an operator confirms availability." },
    { title: 'We handle the rest', body: 'Document collection, operator confirmation, and a flight briefing the day before — we take care of everything between booking and landing.' },
    { title: 'Fly', body: 'Arrive at the helipad ' + arrivalBeforeMin + ' minutes before departure. Your pilot will brief you on-site.' },
  ];
}
export const HOW_IT_WORKS_HEADING = 'From enquiry to touchdown in 4 steps';

export function pricingPromise(fullPaymentOnlyDays) {
  const days = fullPaymentOnlyDays || 7;
  return {
    heading: 'The price you see is the price you pay',
    body: 'We show the full aircraft price -- not per seat. No fuel surcharges added at checkout. No hidden "operational fees". VAT (13%) is shown clearly and separately. Enter your route and get an instant, fixed quote.',
    fine: 'Pricing is per flight, not per seat. A deposit secures your booking; the balance is due before departure. For flights within ' + days + ' days, full payment is required. Groups of 3-5 often find helicopter charter very competitive compared to business-class ferry or domestic flights.',
    points: [
      { title: 'Full aircraft -- no shared seats', body: 'Every charter is private. You book the whole aircraft for your group. No other passengers.' },
      { title: 'Deposit or full payment', body: 'A deposit secures your booking. For flights within ' + days + ' days, full payment is required. Cancellation terms vary by operator and are shown during booking.' },
      { title: 'Weather protection included', body: 'If your flight is cancelled due to weather, you receive a full refund (3% processing fee retained) or a free rebook.' },
      { title: 'No credit card surcharges', body: 'We accept major cards, bank transfer, and selected digital payment methods.' },
    ],
  };
}
